import React from 'react';
import { motion } from 'framer-motion';

const Approach = () => {
  const phases = [
    {
      number: "01",
      title: "Discovery & Synthesis",
      description: "Deep assessments to uncover hidden patterns and leverage points"
    },
    {
      number: "02",
      title: "Framework Development",
      description: "Bespoke methodology creation tailored to your unique organizational DNA"
    },
    {
      number: "03",
      title: "Implementation Architecture",
      description: "Systematic deployment with embedded feedback loops and adaptive mechanisms"
    },
    {
      number: "04",
      title: "Sustainable Integration",
      description: "Long-term capability building to ensure enduring transformation"
    }
  ];

  return (
    <section id="approach" className="py-24 bg-slate-800/30">
      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-serif text-slate-100 mb-6">
            Our Approach
          </h2>
          <div className="w-16 h-px bg-amber-400 mx-auto mb-8" />
          <p className="text-xl text-slate-300 max-w-3xl mx-auto leading-relaxed">
            A systematic yet adaptive methodology that honors both scientific rigor 
            and the art of organizational transformation.
          </p>
        </motion.div>

        <div className="space-y-8">
          {phases.map((phase, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: index % 2 === 0 ? -30 : 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              className="flex items-center space-x-8 group"
            >
              <div className="flex-shrink-0">
                <div className="w-20 h-20 bg-gradient-to-br from-amber-400 to-amber-600 rounded-full flex items-center justify-center">
                  <span className="text-slate-900 font-bold text-lg">
                    {phase.number}
                  </span>
                </div>
              </div>
              
              <div className="flex-1 bg-slate-800/50 backdrop-blur-sm border border-slate-700/50 rounded-lg p-6 group-hover:border-amber-400/30 transition-all duration-300">
                <h3 className="text-2xl font-semibold text-slate-100 mb-3">
                  {phase.title}
                </h3>
                <p className="text-slate-300 leading-relaxed text-lg">
                  {phase.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Approach;